import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration from config module

/**
 * Class representing a view for table positions.
 * @extends JetView
 */
export default class tablePositionView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatableEmpl',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Enable vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: 'Editar',
                    // Template function to conditionally render the edit icon
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingEmployeesEdit', 'Edit')) {
                            // Return edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return empty string if permission is denied
                            return '';
                        }
                    },
                },
                // Column for employee ID
                { id: 'Id', header: 'ID', width: 60, sort: 'int' },
                // Column for employee name with localization
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' },
                // Column for employee lastname with localization
                {
                    id: 'Lastname',
                    header: _('Apellidos'),
                    width: 100,
                    sort: 'int',
                },
                // Column for document type with editor as combo box
                {
                    id: 'TypeDocument',
                    header: _('Tipo Documento'),
                    editor: 'combo',
                    // Options for document type selection
                    options: [
                        { id: '0', value: _('Cedula') },
                        { id: '1', value: _('Cedula de extrangería') },
                        { id: '2', value: _('Pasaporte') },
                    ],
                    width: 100,
                    sort: 'int',
                },
                // Column for document number
                {
                    id: 'Document',
                    header: _('Documento'),
                    width: 150,
                    sort: 'int',
                },
                // Column for employee position with localization
                { id: 'Position', header: _('Cargo'), width: 150, sort: 'int' },
                // Column for employee area with localization
                { id: 'Area', header: _('Área'), width: 150, sort: 'int' },
                // Column for employee salary with localization
                { id: 'Salary', header: _('Salario'), width: 150, sort: 'int' },
                // Column for employee state with editor as combo box
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for employee state selection
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Trigger the event to open the employee edit form
                    vthis.app.callEvent('openEditEmpl', [{}]);
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // API endpoint for fetching employee data
            url: devConfig.geturlApi() + 'Accounting/GetEmployees',
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize filter and arrays for date popups
        var filter = '';
        var datePopup = [];
        var datePopup2 = [];
        var popupAdd = '';
        // Perform an AJAX request to get position data
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetPositionSelect', '', {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Display error message
                },
                // Handle successful response
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse the JSON response
                    datePopup = resp.Data; // Store position data in datePopup
                    // Perform another AJAX request to get area data
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type for the request
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetAreaSelect', '', {
                            // Handle error response
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Display error message
                            },
                            // Handle successful response
                            success: function (text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parse the JSON response
                                datePopup2 = resp.Data; // Store area data in datePopup2
                                // Create a popup window for adding employees
                                popupAdd = webix.ui({
                                    view: 'window',
                                    width: 750,
                                    id: 'AddEmployees', // Unique ID for the window
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Añadir Empleado'), // Label for the window
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window on click
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window on the screen
                                    modal: true, // Make the window modal
                                    body: {
                                        view: 'form',
                                        id: 'addformEmployee', // Unique ID for the form
                                        elements: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        label: _('Nombre'), // Label for name input
                                                        name: 'Name', // Name of the input field
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                    {
                                                        view: 'text',
                                                        label: _('Apellidos'), // Label for lastname input
                                                        name: 'Lastname', // Name of the input field
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo',
                                                        label: _('Tipo Documento'), // Label for document type combo
                                                        name: 'TypeDocument', // Name of the input field
                                                        options: [
                                                            {
                                                                id: '0',
                                                                value: _('Cedula'), // Option for ID
                                                            },
                                                            {
                                                                id: '1',
                                                                value: _('Cedula de extrangería'), // Option for foreign ID
                                                            },
                                                            {
                                                                id: '2',
                                                                value: _('Pasaporte'), // Option for passport
                                                            },
                                                        ],
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                    {
                                                        view: 'text',
                                                        label: _('Documento'), // Label for document input
                                                        name: 'Document', // Name of the input field
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo',
                                                        label: _('Cargo'), // Label for position combo
                                                        name: 'Position', // Name of the input field
                                                        options: datePopup, // Options populated from AJAX response
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                    {
                                                        view: 'combo',
                                                        label: _('Área'), // Label for area combo
                                                        name: 'Area', // Name of the input field
                                                        options: datePopup2, // Options populated from AJAX response
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        label: _('Salario'), // Label for salary input
                                                        name: 'Salary', // Name of the input field
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                        type: 'number', // Input type is number
                                                    },
                                                    {
                                                        view: 'combo',
                                                        label: _('Estado'), // Label for state combo
                                                        name: 'State', // Name of the input field
                                                        options: [
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'), // Option for activated state
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'), // Option for deactivated state
                                                            },
                                                        ],
                                                        labelWidth: 140,
                                                        required: true, // Mark as required
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Label for cancel button
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Hide the window on click
                                                            $$('addformEmployee').setValues(
                                                                // Reset form values
                                                                $$('addformEmployee').getCleanValues(),
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        type: 'form',
                                                        value: _('Guardar'), // Label for save button
                                                        click: function ($e) {
                                                            var values = $$('addformEmployee').getValues(); // Get form values
                                                            if ($$('addformEmployee').validate()) {
                                                                // Validate form
                                                                // Perform AJAX request to save employee data
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for the request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Accounting/SaveEmployee',
                                                                        '{"Name":"' +
                                                                            values.Name +
                                                                            '", "Lastname":"' +
                                                                            values.Lastname +
                                                                            '", "TypeDocument":"' +
                                                                            values.TypeDocument +
                                                                            '", "Document":"' +
                                                                            values.Document +
                                                                            '", "Position":"' +
                                                                            values.Position +
                                                                            '", "Area":"' +
                                                                            values.Area +
                                                                            '", "Salary":"' +
                                                                            values.Salary +
                                                                            '", "State":"' +
                                                                            values.State +
                                                                            '"}',
                                                                        {
                                                                            // Handle error response
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Display error message
                                                                            },
                                                                            // Handle successful response
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Empleado Agregado')); // Display success message
                                                                                grid.clearAll(); // Clear the grid data
                                                                                // Reload the grid with updated data
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=' +
                                                                                        grid.data.$pagesize +
                                                                                        filter,
                                                                                );
                                                                            },
                                                                        },
                                                                    );
                                                                $$('addformEmployee').setValues(
                                                                    // Reset form values
                                                                    $$('addformEmployee').getCleanValues(),
                                                                );
                                                                this.getTopParentView().hide(); // Hide the window
                                                            } else {
                                                                // Display validation error message
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _('Completa los campos...'),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        // Configuration for form elements
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {
                                                    this.validate(); // Validate form on change
                                                },
                                            },
                                        },
                                    },
                                });
                            },
                        });
                },
            });
        // Create a popup window for editing employee details
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditEmployees', // Unique identifier for the window
            head: {
                // Header section of the window
                view: 'toolbar', // Define the header as a toolbar
                cols: [
                    // Columns within the toolbar
                    { view: 'label', label: _('Editar Empleado') }, // Label for the window title
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hide the top parent view (the window)
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                // Body section of the window
                view: 'form', // Define the body as a form
                id: 'editFormEmp', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the element
                            {
                                view: 'text', // Text input for employee ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name of the input field
                                readonly: true, // Make the input read-only
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the element
                            {
                                view: 'text', // Text input for employee name
                                label: _('Nombre'), // Label for the input
                                name: 'Name', // Name of the input field
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for employee lastname
                                label: _('Apellidos'), // Label for the input
                                name: 'Lastname', // Name of the input field
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the element
                            {
                                view: 'combo', // Dropdown for document type
                                label: _('Tipo Documento'), // Label for the input
                                name: 'TypeDocument', // Name of the input field
                                options: [
                                    // Options for the dropdown
                                    { id: '0', value: _('Cedula') }, // Option for Cedula
                                    {
                                        id: '1',
                                        value: _('Cedula de extrangería'), // Option for Cedula de extrangería
                                    },
                                    { id: '2', value: _('Pasaporte') }, // Option for Pasaporte
                                ],
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for document number
                                label: _('Documento'), // Label for the input
                                name: 'Document', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the element
                            {
                                view: 'combo', // Dropdown for employee position
                                label: _('Cargo'), // Label for the input
                                name: 'Position', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'combo', // Dropdown for employee area
                                label: _('Área'), // Label for the input
                                name: 'Area', // Name of the input field
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            // Columns within the element
                            {
                                view: 'text', // Text input for employee salary
                                label: _('Salario'), // Label for the input
                                name: 'Salary', // Name of the input field
                                readonly: true, // Make the input read-only
                                type: 'number', // Input type is number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'combo', // Dropdown for employee state
                                label: _('Estado'), // Label for the input
                                name: 'State', // Name of the input field
                                options: [
                                    // Options for the dropdown
                                    { id: 'A', value: _('Activado') }, // Option for Activated
                                    { id: 'I', value: _('Inactivado') }, // Option for Inactivated
                                ],
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            // Columns for action buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for the button
                                    this.getTopParentView().hide(); // Hide the top parent view (the window)
                                    $$('editFormEmp').setValues(
                                        // Reset the form values
                                        $$('editFormEmp').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for save action
                                type: 'form', // Button type is form
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for the button
                                    var values = $$('editFormEmp').getValues(); // Get form values
                                    webix // Perform an AJAX request to save employee data
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for saving employee
                                                'Accounting/SaveEmployee',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Lastname":"' +
                                                values.Lastname +
                                                '", "TypeDocument":"' +
                                                values.TypeDocument +
                                                '", "Document":"' +
                                                values.Document +
                                                '", "Position":"' +
                                                values.Position +
                                                '", "Area":"' +
                                                values.Area +
                                                '", "Salary":"' +
                                                values.Salary +
                                                '", "State":"' +
                                                values.State +
                                                '"}', // JSON string of employee data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message('Error! '); // Display error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message('Empleado Actualizado'); // Display success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    $$('editFormEmp').setValues(
                                        // Reset the form values
                                        $$('editFormEmp').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the top parent view (the window)
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Bind the edit form to the employee data table
        $$('editFormEmp').bind($$('datatableEmpl'));

        // Listen for the 'employees:filter' event and handle filtering logic
        this.on(this.app, 'employees:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string for filters

            // Iterate over each entry in the filter data
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear existing data in the grid
            grid.clearAll();
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the current filter string
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters and pagination
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    filter + // Additional filter parameters
                    '&sort[' +
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending/descending)
            );
        });

        // Listen for the 'addEmployees:button' event from the application
        this.on(this.app, 'addEmployees:button', (filter) => {
            // Check if the datePopup has any elements
            if (datePopup.length > 0) {
                $$('addformEmployee').clearValidation(); // Clear previous validation errors
                popupAdd.show(); // Show the popup for adding an employee
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message to display
                });
            }
        });

        // Listen for the 'openEditEmpl' event from the application
        this.on(this.app, 'openEditEmpl', (filterData) => {
            // Check if the datePopup has any elements
            if (datePopup.length > 0) {
                popup.show(); // Show the popup for editing an employee
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message to display
                });
            }
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
